import * as React from "react";
import type { SVGProps } from "react";

const SvgDocument = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={24} {...props}>
        <path
            fill="currentColor"
            d="M11.414 0 18 6.586v15.428C18 23.555 17.549 24 16 24H2.035C.455 24 0 23.56 0 22V2C0 .448.448 0 2 0h9.414ZM10 2H2v20h14V8h-6Zm4.585 4L12 3.415V6ZM4 18h10v2H4Zm0-4h10v2H4Zm0-4h10v2H4Z"
        />
    </svg>
);
export default SvgDocument;
